module.exports = __webpack_public_path__ + "img/white-blue-transition-clean.b46204d0.png";